
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30204',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30204",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54416",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7975",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11421",
  "I18n": "static-7.1613",
  "quartz": "static-1.6966",
  "quartz-config": "static-1.744",
  "quartz-core": "static-1.6185",
  "react-dlb": "static-1.78",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.781",
  "enviro": "static-4.428",
  "feedback-shared-ui": "static-1.54403",
  "feedback-utils": "static-1.54407",
  "forms-embed-utils-lib": "static-1.4421",
  "forms-utils-lib": "static-1.12498",
  "foundations-assets": "static-1.4816",
  "foundations-components": "static-1.7850",
  "foundations-theming": "static-1.4377",
  "hub-http": "static-1.6181",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11729",
  "icons": "static-2.644",
  "immutable": "static-2.77",
  "quick-fetch": "static-1.3882",
  "raven": "static-3.5829",
  "react": "static-7.185",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16628",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5310",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.486",
  "tinymce-plugins": "static-1.57354",
  "transmute": "static-2.85",
  "ui-images": "static-2.1142",
  "UIComponents": "static-3.8368",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9542",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3370",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3243",
  "quartz-webpack": "static-1.3190",
  "foundations-theming-specialty": "static-1.2093",
  "property-description-translator": "static-1.3806",
  "HeadJS": "static-2.742",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3086",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4284",
  "jasmine-runner": "static-1.6428",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.828",
  "hubspotter-http": "static-1.4618",
  "mobile-manifest-mixins": "static-1.516",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.641",
  "quartz-head": "static-1.631",
  "quartz-i18n": "static-1.641",
  "quartz-routing": "static-1.396",
  "quartz-test": "static-1.641",
  "quartz-tracking": "static-1.345",
  "ui-fonts": "static-1.683",
  "usage-tracker-container": "static-1.7288",
  "usage-tracker-core": "static-1.7148",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.155",
  "conversations-skeleton-state": "static-1.7208",
  "reference-resolvers": "static-1.8129",
  "sanitize-text": "static-1.8103",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10331",
  "sanitize": "static-1.4432",
  "outpost": "static-1.4147",
  "rpc-client-utils": "static-1.4610",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4119",
  "floating-ui": "static-1.55",
  "hs-story-utils": "static-1.9389",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.12",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1721",
  "bend-plugin-foundations-theming": "static-1.2860",
  "foundations-theming-base": "static-1.3362",
  "stylex": "static-1.32",
  "hs-locale-management": "static-1.50",
  "csstype": "static-1.50",
  "web-vitals": "static-1.4",
  "ai-components-ui-library": "static-1.8829",
  "atom": "static-1.5032",
  "codemirror": "static-5.94",
  "content-assistance-lib": "static-1.7686",
  "ContentUtils": "static-1.68231",
  "data-token-picker": "static-1.16331",
  "file-manager-components": "static-1.23499",
  "FileManagerCore": "static-1.38998",
  "FileManagerLib": "static-1.39139",
  "frontend-preferences-client": "static-1.7887",
  "hub-http-contrib": "static-1.3000",
  "interframe": "static-3.4721",
  "layout-dnd-components": "static-1.12362",
  "layout-dnd-utils": "static-1.11337",
  "property-translator": "static-1.5361",
  "react-codemirror": "static-1.10583",
  "react-colorpicker": "static-2.10170",
  "reference-resolvers-lite": "static-1.8054",
  "rich-text-lib": "static-1.19757",
  "tinymce-data": "static-1.40325",
  "tinymce-themes": "static-1.56210",
  "ui-addon-emoji-picker": "static-1.9848",
  "ui-addon-sales-email": "static-1.5170",
  "ui-brand-identity-lib": "static-1.15067",
  "bender-build-tools": "static-1.3123",
  "hub-http-shared-msw-handlers": "static-1.9863",
  "hubspotter-http-shared-msw-handlers": "static-1.9861",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4984",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.20",
  "chirp-fetch": "static-1.1845",
  "chatspot-core": "static-1.21066",
  "copilot-toolkit": "static-1.11000",
  "customer-data-objects-ui-components": "static-1.12985",
  "data-fetching-client": "static-1.9633",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4726",
  "ui-addon-video-player": "static-1.8658",
  "ui-coaching-tips": "static-1.28419",
  "usage-tracker": "static-1.7298",
  "cms-field-types": "static-1.4771",
  "content-icons-ui": "static-1.2215",
  "integrations-lib": "static-1.15972",
  "customer-data-objects": "static-1.7622",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4608",
  "apollo-stack-hubspot": "static-3.85",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "immerable": "static-1.4113",
  "ui-addon-iframeable": "static-1.9015",
  "video-components-external": "static-1.11119",
  "video-data-lib": "static-1.34777",
  "audio-components": "static-1.5851",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29218",
  "FileManagerImages": "static-1.36650",
  "foundations-components-legacy": "static-1.875",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.524",
  "ui-universal-auth": "static-1.8923",
  "urlinator": "static-1.4491",
  "video-components": "static-1.13122",
  "video-embed": "static-1.35611",
  "ts-schema": "static-1.4044",
  "ContentData": "static-1.68306",
  "layout-data-lib": "static-1.9662",
  "react-dnd-compat": "static-1.4580",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1508",
  "external-options-client-types": "static-1.4124",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6839",
  "hs-promise-utils": "static-1.5553",
  "inbound-db-properties-service-client": "static-1.3806",
  "NamespacedHubStyle": "static-2.9028",
  "growth-onboarding-confetti": "static-1.3027",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11110",
  "amplitude-session-replay-browser": "static-1.59",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5533",
  "magpie-types": "static-1.4993",
  "simple-logging-lib": "static-1.3009",
  "avatar-components": "static-1.2458",
  "customer-data-ui-utilities": "static-1.9786",
  "growth-onboarding-feedback-components": "static-1.6543",
  "flux-actions": "static-1.331",
  "hubspot-apollo-client": "static-1.4836",
  "integrations-error-boundary-lib": "static-1.13387",
  "integrations-tracking-lib": "static-1.5558",
  "laboratory-lib": "static-3.7118",
  "native-integrations-shared-strings": "static-1.7743",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10109",
  "unified-auth": "static-1.437",
  "navigation-messaging": "static-1.7213",
  "content-media-composition-data-lib": "static-1.12100",
  "content-media-compositions": "static-2.16107",
  "idb-keyval": "static-1.43",
  "media-bridge-lib": "static-1.18853",
  "unified-auth-core-lib": "static-1.718",
  "social-insights-client-types": "static-1.21963",
  "advanced-menus-core": "static-1.15060",
  "advanced-menus-lib": "static-1.12010",
  "ExportDialog": "static-6.10353",
  "ui-memberships-settings-lib": "static-1.33923",
  "conditional-properties-service-client": "static-1.3763",
  "crm-pipelines-api-client-types": "static-1.4108",
  "framework-builder-read-service-client": "static-1.3975",
  "framework-data-schema-quick-fetch": "static-1.6744",
  "inbound-db-meta-service-client": "static-1.3556",
  "multi-currency-client-types": "static-1.3657",
  "persist-promise": "static-1.3665",
  "foundations-components-test-utils": "static-1.5333",
  "reactive-lib": "static-1.681",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.295",
  "universal-page-editor-lib": "static-1.2972",
  "google-sheets-integration-lib": "static-1.103",
  "microsoft-drive-integration-lib": "static-1.216",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3692",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15059",
  "simple-menus-lib": "static-1.16576",
  "crm-record-cards-service-types": "static-1.3575",
  "location-customization-utils-lib": "static-1.9109",
  "react-flip-move": "static-1.69"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30204",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54416",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7975",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11421",
  "I18n": "/I18n/static-7.1613",
  "quartz": "/quartz/static-1.6966",
  "quartz-config": "/quartz-config/static-1.744",
  "quartz-core": "/quartz-core/static-1.6185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.781",
  "enviro": "/enviro/static-4.428",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54403",
  "feedback-utils": "/feedback-utils/static-1.54407",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4421",
  "forms-utils-lib": "/forms-utils-lib/static-1.12498",
  "foundations-assets": "/foundations-assets/static-1.4816",
  "foundations-components": "/foundations-components/static-1.7850",
  "foundations-theming": "/foundations-theming/static-1.4377",
  "hub-http": "/hub-http/static-1.6181",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11729",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.77",
  "quick-fetch": "/quick-fetch/static-1.3882",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.185",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16628",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5310",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tinymce-plugins": "/tinymce-plugins/static-1.57354",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1142",
  "UIComponents": "/UIComponents/static-3.8368",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9542",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3370",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3243",
  "quartz-webpack": "/quartz-webpack/static-1.3190",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2093",
  "property-description-translator": "/property-description-translator/static-1.3806",
  "HeadJS": "/HeadJS/static-2.742",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3086",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4284",
  "jasmine-runner": "/jasmine-runner/static-1.6428",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "hubspotter-http": "/hubspotter-http/static-1.4618",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.516",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.641",
  "quartz-head": "/quartz-head/static-1.631",
  "quartz-i18n": "/quartz-i18n/static-1.641",
  "quartz-routing": "/quartz-routing/static-1.396",
  "quartz-test": "/quartz-test/static-1.641",
  "quartz-tracking": "/quartz-tracking/static-1.345",
  "ui-fonts": "/ui-fonts/static-1.683",
  "usage-tracker-container": "/usage-tracker-container/static-1.7288",
  "usage-tracker-core": "/usage-tracker-core/static-1.7148",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.155",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7208",
  "reference-resolvers": "/reference-resolvers/static-1.8129",
  "sanitize-text": "/sanitize-text/static-1.8103",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10331",
  "sanitize": "/sanitize/static-1.4432",
  "outpost": "/outpost/static-1.4147",
  "rpc-client-utils": "/rpc-client-utils/static-1.4610",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4119",
  "floating-ui": "/floating-ui/static-1.55",
  "hs-story-utils": "/hs-story-utils/static-1.9389",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.12",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1721",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2860",
  "foundations-theming-base": "/foundations-theming-base/static-1.3362",
  "stylex": "/stylex/static-1.32",
  "hs-locale-management": "/hs-locale-management/static-1.50",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.4",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8829",
  "atom": "/atom/static-1.5032",
  "codemirror": "/codemirror/static-5.94",
  "content-assistance-lib": "/content-assistance-lib/static-1.7686",
  "ContentUtils": "/ContentUtils/static-1.68231",
  "data-token-picker": "/data-token-picker/static-1.16331",
  "file-manager-components": "/file-manager-components/static-1.23499",
  "FileManagerCore": "/FileManagerCore/static-1.38998",
  "FileManagerLib": "/FileManagerLib/static-1.39139",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7887",
  "hub-http-contrib": "/hub-http-contrib/static-1.3000",
  "interframe": "/interframe/static-3.4721",
  "layout-dnd-components": "/layout-dnd-components/static-1.12362",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11337",
  "property-translator": "/property-translator/static-1.5361",
  "react-codemirror": "/react-codemirror/static-1.10583",
  "react-colorpicker": "/react-colorpicker/static-2.10170",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8054",
  "rich-text-lib": "/rich-text-lib/static-1.19757",
  "tinymce-data": "/tinymce-data/static-1.40325",
  "tinymce-themes": "/tinymce-themes/static-1.56210",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9848",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5170",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15067",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9863",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9861",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4984",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.20",
  "chirp-fetch": "/chirp-fetch/static-1.1845",
  "chatspot-core": "/chatspot-core/static-1.21066",
  "copilot-toolkit": "/copilot-toolkit/static-1.11000",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12985",
  "data-fetching-client": "/data-fetching-client/static-1.9633",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4726",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8658",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28419",
  "usage-tracker": "/usage-tracker/static-1.7298",
  "cms-field-types": "/cms-field-types/static-1.4771",
  "content-icons-ui": "/content-icons-ui/static-1.2215",
  "integrations-lib": "/integrations-lib/static-1.15972",
  "customer-data-objects": "/customer-data-objects/static-1.7622",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4608",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4113",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9015",
  "video-components-external": "/video-components-external/static-1.11119",
  "video-data-lib": "/video-data-lib/static-1.34777",
  "audio-components": "/audio-components/static-1.5851",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29218",
  "FileManagerImages": "/FileManagerImages/static-1.36650",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.875",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.524",
  "ui-universal-auth": "/ui-universal-auth/static-1.8923",
  "urlinator": "/urlinator/static-1.4491",
  "video-components": "/video-components/static-1.13122",
  "video-embed": "/video-embed/static-1.35611",
  "ts-schema": "/ts-schema/static-1.4044",
  "ContentData": "/ContentData/static-1.68306",
  "layout-data-lib": "/layout-data-lib/static-1.9662",
  "react-dnd-compat": "/react-dnd-compat/static-1.4580",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1508",
  "external-options-client-types": "/external-options-client-types/static-1.4124",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6839",
  "hs-promise-utils": "/hs-promise-utils/static-1.5553",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3806",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9028",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3027",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11110",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5533",
  "magpie-types": "/magpie-types/static-1.4993",
  "simple-logging-lib": "/simple-logging-lib/static-1.3009",
  "avatar-components": "/avatar-components/static-1.2458",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9786",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6543",
  "flux-actions": "/flux-actions/static-1.331",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4836",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13387",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5558",
  "laboratory-lib": "/laboratory-lib/static-3.7118",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7743",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10109",
  "unified-auth": "/unified-auth/static-1.437",
  "navigation-messaging": "/navigation-messaging/static-1.7213",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12100",
  "content-media-compositions": "/content-media-compositions/static-2.16107",
  "idb-keyval": "/idb-keyval/static-1.43",
  "media-bridge-lib": "/media-bridge-lib/static-1.18853",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.718",
  "social-insights-client-types": "/social-insights-client-types/static-1.21963",
  "advanced-menus-core": "/advanced-menus-core/static-1.15060",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12010",
  "ExportDialog": "/ExportDialog/static-6.10353",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33923",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3763",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4108",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3975",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6744",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3556",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3657",
  "persist-promise": "/persist-promise/static-1.3665",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5333",
  "reactive-lib": "/reactive-lib/static-1.681",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.295",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2972",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.103",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.216",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3692",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15059",
  "simple-menus-lib": "/simple-menus-lib/static-1.16576",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3575",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9109",
  "react-flip-move": "/react-flip-move/static-1.69"
}
};
